import React, { useState, useEffect } from "react";
import {
  Typography,
  Button,
  Icon,
  IconButton,
  makeStyles,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  Grid,
  Switch,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CreateIcon from "@material-ui/icons/Create";
import { Link } from "react-router-dom";
import Loader from "../../components/Loader";

import { VEHICLE } from "../../configs/urls";
import { getApi, deleteApi, putApi } from "../../services/api";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "100%",
    margin: "auto",
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  marginLeft: {
    marginLeft: 10,
  },
}));

export default function Vehicles() {
  const classes = useStyles();
  const [vehicles, setVehiclesList] = useState([]);
  const [isRequesting, setIsRequestig] = useState(false);
  const [params, setParams] = useState({ page: 0 });
  // const [totalVehiclesCount, setTotalVehiclesCount] = useState(0)

  useEffect(() => {
    fetchVehicles(true);
  }, []); //eslint-disable-line

  const fetchVehicles = (isInitialLoad) => {
    setIsRequestig(true);

    getApi(VEHICLE, params)
      .then(
        (res) => {
          // if (isInitialLoad) setTotalVehiclesCount(res.meta.total);

          const data = res.data || [];
          const newUserList = [...vehicles, ...data];
          setVehiclesList(newUserList);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const deleteVehicle = (id, idx) => {
    setIsRequestig(true);
    deleteApi(VEHICLE + "/" + id)
      .then(
        (res) => {
          let vehiclesData = vehicles;
          vehiclesData.splice(idx, 1);
          setVehiclesList(vehiclesData);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const loadMoreVehicle = () => {
    setParams({ ...params, page: (params.page += 1) });
    fetchVehicles();
  };

  const handleStatusChange = (vehicle, idx) => {
    setIsRequestig(true);
    const params = {
      id: vehicle.id,
      active: vehicle.active == 1 ? 0 : 1,
    };
    putApi(VEHICLE, params)
      .then(
        () => {
          let list = [...vehicles];
          list[idx].active = params.active;
          setVehiclesList(list);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequestig(false);
      });
  };

  const renderVehicle = () => (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="caption table">
        <TableHead>
          <TableRow>
            <TableCell>Sr. No.</TableCell>
            <TableCell>type</TableCell>
            <TableCell>Unique number</TableCell>
            <TableCell>Brand Name</TableCell>
            <TableCell>Year</TableCell>
            <TableCell>Ownership</TableCell>
            <TableCell>Owner Name</TableCell>
            <TableCell>Registration number</TableCell>
            <TableCell>Hours</TableCell>
            <TableCell>Warranty</TableCell>
            <TableCell>Warranty Start Date</TableCell>
            <TableCell>Warranty Start Date</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Active</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {vehicles.map((vehicle, idx) => (
            <TableRow key={idx}>
              <TableCell>{idx + 1}</TableCell>
              <TableCell>{vehicle.type ? vehicle.type.name : "--"}</TableCell>
              <TableCell>{vehicle.unique_number || "--"}</TableCell>
              <TableCell>{vehicle.make || "--"}</TableCell>
              <TableCell>{vehicle.year || "--"}</TableCell>
              <TableCell>{vehicle.ownership || "--"}</TableCell>
              <TableCell>{vehicle.owner_name || "--"}</TableCell>
              <TableCell>{vehicle.registration_number || "--"}</TableCell>
              <TableCell>{vehicle.hours || "--"}</TableCell>
              <TableCell>{vehicle?.warrent_status}</TableCell>
              <TableCell>{vehicle?.warrent_start_date || "--"}</TableCell>
              <TableCell>{vehicle?.warrent_end_date || "--"}</TableCell>
              <TableCell>{vehicle.status || "--"}</TableCell>
              <TableCell>
                <Switch
                  checked={vehicle.active == 1}
                  onChange={() => {
                    handleStatusChange(vehicle, idx);
                  }}
                  color="primary"
                  name="checkedB"
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
              </TableCell>
              <TableCell align="right">
                <Link to={"/admin/vehicles/operations/" + vehicle.id}>
                  <IconButton edge="end" aria-label="edit">
                    <CreateIcon />
                  </IconButton>
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {/*
        equipments.length < totalUsersCount &&
        <Grid container justify="center" style={{ padding: 20 }}>
          <Button
            variant="outlined"
            color="primary"
            className={classes.button}
            onClick={() => loadMoreUsers()}
          >
            Load More
          </Button>
        </Grid>
      }*/}
    </TableContainer>
  );

  return (
    <div className={classes.root}>
      <Loader isLoading={isRequesting} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Typography variant="h6" className={classes.title}>
              Vehicles
            </Typography>
            <div>
              <Link to="/admin/vehicles/operations">
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  endIcon={<Icon>add_circle</Icon>}
                >
                  Add Vehicle
                </Button>
              </Link>
            </div>
          </Grid>
          {vehicles.length ? (
            renderVehicle()
          ) : (
            <Box
              fontSize="h6.fontSize"
              m={1}
              p={{ xs: 2, sm: 2, md: 2 }}
              style={{ textAlign: "center" }}
            >
              No Vehicle Found
            </Box>
          )}
        </GridItem>
      </GridContainer>
    </div>
  );
}
